import { Icon, IconProps } from '@tabler/icons-react'

interface Props extends IconProps {
	icon: Icon
}

const IconWrapper = (props: Props) => {
	const { icon, stroke = 1.25, size = 24, ...rest } = props

	const Component = icon
	return <Component stroke={stroke} size={size} {...rest} />
}

export default IconWrapper
